import React, { useCallback, useEffect } from 'react'
import { ViewNewsletterStyles } from './Style'
import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { ReactComponent as EditIcon } from 'assets/icons/Edit.svg';
import { useNavigate, useParams } from 'react-router-dom'
import { getNewsletterByIdFetch } from 'store/middlewares/newsletter.crud'
import { stateToHTML } from 'draft-js-export-html'
import { LightButton, ScreenStyles } from 'styles/GlobalStyle'
import { Divider, SvgIcon } from '@mui/material'
import { thirdly2 } from 'styles/theme'
import { customFormatDate, formatDate } from 'utils/formatter'
import { app } from 'router/routes'
import { NewsletterVM } from 'models/VM'
import draftToHtml from 'draftjs-to-html';
import { Title as ScreenTitle } from 'components'
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';

const ViewNewsletter = (props) => {
    const params = useParams()
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const { newsletterID } = params

    const newletterOptions = queryOptions({
        queryKey: [qc.newsletters, newsletterID],
        queryFn: async () => {
            const { data } = await getNewsletterByIdFetch(newsletterID)
            let newsletter = new NewsletterVM(data)
            if (newsletter.content) {
                let editorState = JSON.parse(newsletter.content)
                editorState = draftToHtml(editorState)

                newsletter.content = editorState
            }
            return newsletter
        },
        refetchOnWindowFocus: false,
    })
    const newsletter = useQuery(newletterOptions)
    const { name, description, content, official_release_date } = newsletter.data || {}

    const goEditNews = useCallback(() => navigate(`${app.newsletters}/${newsletterID}/edit/`), [])

    return (
        <ScreenStyles>
            <ScreenTitle {...props} breadcrumbs={true}>
                <div className='bread-crumbs-title'>
                    <div>{">"}</div>
                    {name}
                </div>
            </ScreenTitle>
            <ViewNewsletterStyles>
                <div className='news-header-action'>
                    <LightButton variant="solid" size="small" action={goEditNews} label="עריכה" icon={<SvgIcon fontSize="small" component={EditIcon} inheritViewBox />} />
                </div>
                <div className='view-newsletter'>
                    <div className='news-header'>
                        <div className='wrap-news-title'>
                            <h1 className='news-title'>
                                {name}
                            </h1>
                            <div className='date'>{customFormatDate(official_release_date)}</div>
                        </div>
                        <div className='news-description'>{description}</div>
                    </div>
                    <Divider sx={{ borderColor: thirdly2 }} />
                    <div className='news-content'>
                        {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
                    </div>
                </div>
            </ViewNewsletterStyles>
        </ScreenStyles>
    )
}

export default ViewNewsletter